// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__1WgxS","BreadCrumb":"BreadCrumbs_BreadCrumb__2i8Dl","Child":"BreadCrumbs_Child__31EA9"};